import Vue from 'vue';
import { api } from "../../services/Api.js";
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export function delete_album({ commit, state }, payload){
    // albums => album
    // adding token
    payload.token=state.appSettings.token

    
    modalService.createModal(i18n.t('language.album_delete_sure')).then(
    ()=>{

      // get active school
      var school = state.user_schools.find(school => school.active === 1);

      return api
      .post(school,"delete_album.php",payload)
      .then( () =>{ 
        
        var album=state.albums[payload.store_key].find(album => album.id === payload.id);
        if(album){

          let index = state.albums[payload.store_key].indexOf(album);
          commit('DELETE_ALBUM', {key:payload.store_key ,index:index});
        }
       
        Vue.$toaster.toast("language.album_delete_success");

      })
      .catch( error => {
        alert("store: delete_album: "+error)
      })

    },
    () => {} // cancel modal
    )// modal

  }